import { useEffect } from "react";

declare global {
  interface Window {
    _paq: any;
  }
}

interface MatomoConfig {
  url: string;
  siteId: number;
}

export const useMatomo = ({ url, siteId }: MatomoConfig) => {
  useEffect(() => {
    window._paq = window._paq || [];

    window._paq.push(["trackPageView"]);
    window._paq.push(["enableLinkTracking"]);
    window._paq.push(["setTrackerUrl", `${url}/matomo.php`]);
    window._paq.push(["setSiteId", siteId]);

    const script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.defer = true;
    script.src = `${url}/matomo.js`;
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, [url, siteId]);
};
